const colors = {
	secondary: '#F5F4F7',
	amber: '#DE4848',
	brand: {
		500: '#7ABE73',
		600: '#4DAF89',
		700: '#009B76',
		800: '#4DAF89',
		900: '#707070',
	},
	white: '#FFFFFF',
	JioCardColor: '#2B3990',
	black: '#000000',
	gray: {
		200: '#ADADAD',
		300: '#E1E1E1',
		400: '#5A5A5A',
		500: '#F1F3F9',
		600: '#D9D9D9',
		700: '#DDDFE9',
		800: '#7E7E7E',
	},
	yellow: {
		600: '#FFDE55',
	},
	red: {
		500: '#FF6666',
		600: '#EF3D3D',
	},
	blue: {
		600: '#42529C',
	},
	orange: {
		500: '#FF9800',
	},
}
export default colors
